import {BasicService} from '../../_base/services/basic.service';

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_PRODUCT_SESSION_URL } from '../../connection.data';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import * as _ from "lodash";
import { QueryResultsModel } from '../../_base/crud';

@Injectable()
export class ProductSessionService extends BasicService {
    constructor(http: HttpClient){
        super(http);
        this.baseUrl = API_PRODUCT_SESSION_URL;
    }

    /**
     * Actualiza una sesión y conserva la respuesta completa de la API.
     *
     * BasicService.edit() mantiene el contrato histórico de devolver solo
     * response.status. El flujo de Registrar producción necesita además los
     * metadatos de la API (por ejemplo request_id) cuando una operación falla,
     * por lo que se expone este método sin cambiar el contrato existente.
     */
    editWithResponse(item: any): Observable<any> {
        return this.http.put<any>(`${this.baseUrl}/${item.id}`, item);
    }

    lastByMachine(machineId: number | string): Observable<any>{
        return this.getPage({
            filter: {
                machine_id: machineId
            },
            option: null,
            pageNumber: 0,
            pageSize: 1,
            sortField: 'id',
            sortOrder: 'desc',
        }).pipe(
            // tap((resp: QueryResultsModel)=>console.log(`xtest last by machine ${machineId}: `, resp)),
            map((resp: QueryResultsModel)=>resp.items[0]),
            // tap((resp: QueryResultsModel)=>console.log(`xtest last by machine ${machineId} items[0]: `, resp)),
        )
    }

    periodMachine(sd: string, ed: string, machineId: number | string): Observable<any>{
        return this.getPage({
            filter: {
                machine_id: machineId,
                sd,
                ed
            },
            option: null,
            pageNumber: 0,
            pageSize: 0,
            sortField: 'id',
            sortOrder: 'desc',
        }).pipe(
            // tap((resp: QueryResultsModel)=>console.log(`xtest last by machine ${machineId}: `, resp)),
            map((resp: QueryResultsModel)=>resp.items),
            // tap((resp: QueryResultsModel)=>console.log(`xtest last by machine ${machineId} items[0]: `, resp)),
        )
    }
}
